var $ = require('jQuery');
var _ = require('underscore');
var Audio = require('../../lib/audio.js');
var AutoSaver = require('autosaver');
var Cards = require('../../lib/cards.js');
var tectoastr = require('../../lib/tectoastr.js');
var VideoPlayer = require('../../lib/video-player.js');
var VideoModal = require('../../lib/video-modal.js');
var VideoThumbnails = require('../../lib/video-thumbnails.js');
var Slider = require('../../lib/slider.js');

module.exports = function()
{
    /**
     * Handle conflictOfInterest checkbox
     */
    var toggleConflictOfInterest = function () {
        var checked = $('form #conflictOfInterest').prop('checked');
        $('.conflictOfInterest-show').toggleClass('hidden', !checked);
    };

    /**
     * Removes all error notices from scores.
     */
    var clearErrors = function () {
        var scores = $('[name^="scores["]').parents('.form-group');

        scores.removeClass('error');
        scores.find('p#validation-error').remove();
    };

    /**
     * Displays autosave error messages.
     */
    var handleAutosaveErrors = function (response) {
        switch (response.status) {
            case 403:
                tectoastr.error(response.responseJSON.message);
                break;
            case 422:
                var errors = response.responseJSON;
                tectoastr.error(_.flatten(_.values(errors)).join('<br>'));
                highlightInvalidScores(errors);
                break;
        }
    };

    /**
     * Adds visual indicators to scores that failed validations.
     */
    var highlightInvalidScores = function (errors) {
        _.each(errors, function (message, id) {
            var score = $("[name=\""+id+"\"]").parents('.form-group');

            score.addClass('error');
            score.find('p#validation-error').remove();
            score.append('<p id="validation-error">'+_.flatten(_.values(message)).join('<br>')+'</p>');
        })
    };

    $('form #conflictOfInterest').on('click', toggleConflictOfInterest);
    toggleConflictOfInterest();

    /**
     * AutoSaver
     */
    var autosaver = new AutoSaver($('form.autosave'), clearErrors, handleAutosaveErrors);

    autosaver.setSupressWarnings(true);

    $('form.autosave .scoring-autosave[data-target]').on('click', function () {
        autosaver.setSupressWarnings(false);
        autosaver.saveClose($(this).data('target'));
    });

    /**
     * Cards
     */
    var cards = new Cards;
    cards.setup('ul.cards', 'li', 'fitRows');

    /**
     * Audio
     */
    var audio = new Audio;
    audio.setup('jp-jplayer');

    /**
     * Video
     */
    var videoPlayer = new VideoPlayer;
    var videoModal = new VideoModal;
    var videoThumbnails = new VideoThumbnails;

    videoPlayer.setup('video-js-standalone');
    videoModal.setup('play-video');
    videoThumbnails.setup('preview-container.video');

    /**
     * Initialise slider
     */
    var slider = new Slider();

    var sliders = slider.setup('[id^="slider-"]');
    var unlockedSliders = sliders.filter(slider => !$(slider.getElement()).next('input:hidden').hasClass('locked-score'));

    /**
     * Handle abstain checkbox
     */
    var toggleAbstained = function () {
        var checked = $('form #abstain').prop('checked');

        if (checked) {
          $('.abstain-show').removeClass('hidden');
          $('.abstain-hide').addClass('hidden');
        } else {
          $('.abstain-show').addClass('hidden');
          $('.abstain-hide').removeClass('hidden');
        }

        $('.abstain-disable:not(.locked-score)').prop('disabled', checked);

        unlockedSliders.forEach(slider => {
            if (checked) {
                slider.disable();
            } else {
                slider.enable();
            }
        });
    };

    $('form #abstain').on('click', toggleAbstained);

    toggleAbstained();
};
